export const ar = {
  globals: {
    save: "save",
    submit: "submit",
    cancel: "إلغاء",
  },
  auth: {
    emailId: " البريد الإلكتروني",
    password: "كلمة المرور",
    remember: "تذكرني",
    forgotPassword: "نسيت كلمة المرور",
    oldPass: "كلمة المرور القديمة",
    confmPas: "تأكيد كلمة المرور",
    otpVerification: "التحقق من OTP",
    verify: "تحقق",
    resendOtp: "إعادة إرسال OTP",
    login: "تسجيل الدخول",
    resendPass: "إعادة تعيين كلمة المرور",
    editProfile: "تعديل الملف الشخصي",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    changePassword: "تغيير كلمة المرور",
    resetPasswordTitle: "إعادة تعيين كلمة المرور",
    oldPasswordRequired: "كلمة المرور القديمة مطلوبة.",
    newPasswordRequired: "كلمة المرور الجديدة مطلوبة.",
    confirmPasswordRequired: "تأكيد كلمة المرور مطلوب.",
    passwordsMustMatch: "كلمات المرور يجب أن تتطابق.",
    newPasswordSameAsOld: "كلمة المرور الجديدة لا يمكن أن تكون نفس القديمة.",
    passwordChangedSuccess: "تم تغيير كلمة المرور بنجاح",
    passwordResetSuccess: "تم إعادة تعيين كلمة المرور بنجاح",
  },

  main: {
    Sort: "الترتيب حسب الحروف الهجائية",
    Sort2: "الترتيب حسب لا. من الخصائص",
    Option1: "من الألف إلى الياء",
    Option2: "ي إلى أ",
    Option3: "من أسفل إلى أعلى",
    Option4: "عالية إلى منخفضة",
    image: "صورة",
    addCategory: "إضافة نوع عقار",
    editCategory: "تعديل نوع عقار",
    catName: "اسم العقار",
    selectCat: "اختر نوع العقار",
    address: "العنوان",
    addSubAdmin: "إضافة مسؤول فرعي",
    addEdit: "إضافة/تعديل",
    accountStatus: "حالة الحساب",
    viewUser: "عرض العميل",
    editCustomer: "تعديل العميل",
    question: "سؤال",
    answer: "إجابة",
    contactSupport: "التواصل مع الدعم",
    privacyPolicy: "سياسة الخصوصية",
    aboutUs: "معلومات عنا",
    terms: "الشروط والأحكام",
    changeLang: "تغيير اللغة",
    notification: "الإشعارات",
    seeAll: "عرض الكل",
    myProfile: "ملفي الشخصي",
    logout: "تسجيل الخروج",
    showing: "عرض",
    items: "عناصر",
    active: "نشط",
    Inactive: "غير نشط",
    subscription: "الاشتراك",
    message: "رسالة",
    receiver: "المستلم",
    broadcast: "بث",
    atLeast1Feature: "يجب اختيار ميزة واحدة على الأقل",
    loginToRe: "تسجيل الدخول إلى إدارة العقارات",
    date: "التاريخ",
    credits: "الرصيد",
    addCredits: "إضافة رصيد",
    export: "تصدير CSV",
    subCat: "الفئة الفرعية",
    addSubCat: "إضافة فئة فرعية",
    governorate: "المحافظة",
    propertyName: "اسم العقار",
    confirmDelete: "هل أنت متأكد أنك تريد حذف هذا",
    Yes: "نعم",
    No: "لا",
    Back: "خلف",
    Delete: "يمسح",
    Title: "عنوان",
    SNo: "رقم S",
    AcountStatus: "حالة الحساب",
    Action: "فعل",
    Label: "التسمية",
    Status: "حالة",
    Name: "اسم",
    Description: "وصف",
    Price: "سعر",
    Email: "بريد إلكتروني",
    PhoneNo: "رقم الهاتف",
    PlanPrice: "سعر الخطة",
    PlanName: "اسم الخطة",
    TotalCreditsLeft: "إجمالي الاعتمادات المتبقية",
    TotalCreditsPending: "مجموع الاعتمادات المعلقة",
    Totalcreditsused: "إجمالي الاعتمادات المستخدمة",
    TotalCredits: "إجمالي الائتمان",
    TotalCredits2: "إجمالي الاعتمادات (الاشتراك)",
    TotalCreditsLeft2: "إجمالي الاعتمادات المتبقية (الاشتراك)",
    Totalcreditsused2: "إجمالي الاعتمادات المستخدمة (الاشتراك)",
    PlanDetails: "تفاصيل الخطة",
    CreditDetails: "تفاصيل الائتمان",
    acceptRequestsLeft: "الطلبات المعلقة",
    acceptRequests: "إجمالي الطلبات",
    Governorate: "محافظة",
    NoAreaFound: "لم يتم العثور على منطقة",
    AddGovernorate: "أضف المحافظة",
    ManageAreas: "إدارة المناطق",
    NormalListingCredits: "اعتمادات القائمة العادية",
    HighlightedListingCredits: "أرصدة القائمة المميزة",
    ManageSubscriptionPlan: "إدارة خطة الاشتراك",
    PurchasedSubscriptions: "الاشتراكات المشتراة",
    AddPlan: "أضف خطة",
    Image: "صورة",
    CategoryName: "اسم التصنيف",
    SubCategory: "تصنيف فرعي",
    NoCategoryFound: "لم يتم العثور على فئة",
    ManageCategories: "إدارة الفئات",
    AddSubcategory: "إضافة فئة فرعية",
    ManageSubAdmin: "إدارة المشرف الفرعي",
    Phone: "هاتف",
    Nosubadminsfound: "لم يتم العثور على مشرفين فرعيين.",
    Add: "يضيف",
    PropertiesforSale: "عقارات للبيع",
    PropertiesforRent: "عقارات للإيجار",
    PropertiesforExchange: "خصائص للتبادل",
    MostViewedProperties: "العقارات الأكثر مشاهدة",
    MostSearchedProperties: "العقارات الأكثر بحثا",
    Pleaseselectcategory: "الرجاء تحديد الفئة",
    Type: "يكتب",
    Location: "موقع",
    CustomerName: "اسم الزبون",
    AgentName: "اسم العميل",
    PropertyCategory: "فئة العقار",
    PropertyName: "اسم الخاصية",
    NoPropertiesFound: "لم يتم العثور على خصائص",
    Mostsearchedbyarea: "الأكثر بحثا حسب المنطقة",
    UserPreferences: "خيارات المستخدم",
    All: "الجميع",
    ManageProperties: "إدارة الخصائص",
    VideoTitle: "عنوان مقطع الفيديو",
    AddTutorial: "إضافة البرنامج التعليمي",
    NoTutorialFound: "لم يتم العثور على البرنامج التعليمي",
    ManageTutorials: "إدارة البرامج التعليمية",
    ManagePayments: "إدارة المدفوعات",
    PaymentMode: "طريقة الدفع",
    PaymentType: "نوع الدفع",
    Amount: "كمية",
    TotalEarnings: "الأرباح الكلية",
    ReportsandAnalytics: "التقارير والتحليلات",
    EditProfile: "تعديل الملف الشخصي",
    Save: "يحفظ",
    PhoneNumber: "رقم التليفون",
    FirstName: "الاسم الأول",
    LastName: "اسم العائلة",
    FullName: "الاسم الكامل",
    EditAgentProfile: "تحرير ملف تعريف الوكيل",
    EditTutorial: "تحرير البرنامج التعليمي",
    UploadVideos: "تحميل أشرطة الفيديو",
    DescriptionArabic: "الوصف (عربي)",
    TitleArabic: "العنوان (عربي)",
    ContactSupport: "اتصل بالدعم",

    PrivacyPolicy: "سياسة الخصوصية",
    TermsConditions: "البنود و الظروف",
    AgentTermsConditions: "شروط وأحكام الوكيل",
    CreditPrice: "سعر الائتمان",
    RealEstateLinks: "الروابط العقارية",
    AppSettings: "إعدادات التطبيق",
    AppUpdate: "تحديث التطبيق",
    ForceUpdate: "تحديث إجباري",
    Maintenance: "الصيانة",
    ManageSettings: "إدارة الإعدادات",
    WhatsappPhoneNumber: "رقم هاتف واتس اب",
    PrivacyPolicyEnglish: "سياسة الخصوصية (الإنجليزية)",

    Pleaseenterprivacypolicy: "الرجاء إدخال سياسة الخصوصية",
    PrivacyPolicyArabic: "Privacy Policy ( Arabic )",
    PleaseenterTermsandConditions: "سياسة الخصوصية (العربية)",
    TermsConditionsArabic: "الشروط والأحكام (العربية)",
    TermsConditionsEnglish: "الشروط والأحكام (الإنجليزية)",
    NormalCredits: "الاعتمادات العادية",
    HighlightedCredits: "الاعتمادات المميزة",
    agentRequestPrice: "سعر طلب العقار لكل وكيل",
    TotalUsers: "إجمالي المستخدمين",
    ManageNotifications: "إدارة الإخطارات",
    AddNotification: "إضافة الإخطار",
    NoNotificationFound: "لم يتم العثور على أي إشعار",
    receivedNotifications: "الإشعارات المستلمة",
    Filter: "تصفية",
    kd: "د.ك",
    EditUserProfile: "تحرير ملف تعريف المستخدم",
    ManageFaqs: "إدارة الأسئلة الشائعة",

    QuestionEnglish: "السؤال (الإنجليزية)",
    QuestionArabic: "سؤال (عربي)",
    AnswerEnglish: "الإجابة (الإنجليزية)",
    AnswerArabic: "الإجابة (العربية)",
    Remove: "يزيل",
    Arabic: "عربي",
    English: "إنجليزي",
    PaymentDetails: "بيانات الدفع",
    NotificationTitle: "عنوان الإخطار",
    SubscriptionPlan: "خطة الاشتراك",
    SelectReceiver: "حدد جهاز الاستقبال",
    Edit: "يحرر",
    Module: "وحدة",
    View: "منظر",
    EditSubscriptionPlan: "تحرير خطة الاشتراك",
    PlanValidity: "صلاحية الخطة",
    PlanFeatures: "ميزات الخطة",
    Feature: "ميزة",
    AddSubscriptionPlan: "إضافة خطة الاشتراك",
    EditSubAdmin: "تحرير المشرف الفرعي",
    AddSubAdmin: "إضافة مشرف فرعي",
    Showrequesttoagents: "عرض الطلب على الوكلاء",
    ManageRequest: "إدارة الطلب",
    Month: "شهر",
    Months: "شهور",
    Day: "يوم",
    Days: "أيام",
    Hour: "ساعة",
    Hours: "ساعات",
    Minute: "دقيقة",
    Minutes: "دقائق",
    ValidityUnit: "وحدة الصلاحية",
    PleaseselectValidity: "الرجاء تحديد الصلاحية",
    Category: "فئة",
    NoSubcategoryFound: "لم يتم العثور على فئة فرعية",
    ManageSubCategory: "إدارة الفئة الفرعية",
    Validity: "صلاحية",
    Area: "منطقة",
    Please: "لو سمحت",
    Total: "المجموع",
    Map: "خريطة",
    Link: "وصلة",
    Agent: "عامل",
    User: "مستخدم",
    Normal: "طبيعي",
    Hightlighted: "أبرز",
    For: "ل",
    Upload: "رفع",
    Property: "ملكية",
    Yourbrowserdoesnotsupportthevideotag:
      "متصفحك الحالي لا يدعم تشغيل الفيديو.",
    Totalareainmetersquare: "المساحة الإجمالية بالمتر المربع",
    dateOfPurchase: "تاريخ الشراء",
    PurchaseDate: "تاريخ الشراء",
    ExpiryDate: "تاريخ انتهاء الصلاحية",
    SubscriptionType: "نوع الاشتراك",
    noactivesubscription: "لا يوجد اشتراك نشط",
    AgentCustomerName: "اسم العميل / الوكيل",
    subCatNameEn: "اسم الفئة الفرعية (إنجليزي)",
    subCatNameAr: "اسم الفئة الفرعية (عربي)",
    subCatName: "اسم الفئة الفرعية",
    categoryNameEn: "اسم الفئة (إنجليزي)",
    categoryNameAr: "اسم الفئة (عربي)",
    viewSubCategories: "عرض الفئات الفرعية",
    manageSubAreas: "إدارة المناطق الفرعية",
  },
  dashboard: {
    dashboard: "لوحة التحكم",
    totalUsers: "إجمالي المستخدمين",
    totalAgent: "إجمالي الوكلاء",
    totalProperty: "إجمالي العقارات",
    forSale: "عقارات للبيع",
    forRent: "عقارات للإيجار",
    forExchange: "عقارات للتبادل",
    earnings: "إجمالي الأرباح",
    userEarning: "أرباح المستخدمين",
    agentEarning: "أرباح الوكلاء",
    subscriptionEarning: "أرباح الاشتراكات",
    avgEarnings: "متوسط الأرباح الشهرية",
    byArea: "العقارات المبحوثة حسب المنطقة",
    Earning: "الأرباح",
    User: "المستخدمين",
    Property: "ملكيات",
    ExportCsv: "تصدير ملف CSV",
    Hourly: "ساعيا",
    Weekly: "أسبوعي",
    Monthly: "شهريا",
    Yearly: "سنوي",
    Select: "يختار",
    refresh: "تحديث",
  },
  sideBar: {
    dashboard: "لوحة التحكم",
    subAdmin: "إدارة المسؤولين الفرعيين",
    user: "إدارة المستخدمين",
    agent: "إدارة الوكلاء",
    plans: "إدارة خطط الاشتراك",
    category: "إدارة الفئات",
    property: "إدارة العقارات",
    areas: "إدارة المناطق",
    tutorial: "الدروس الترويجية",
    payments: "إدارة الدفعات",
    noti: "إدارة الإشعارات",
    reports: "التقارير والتحليلات",
    faqs: "إدارة الأسئلة الشائعة",
    setting: "الإعدادات",
    notifications: "إدارة الإخطارات",
    analytics: "التحليلات",
    promotionalCode: "إدارة الرمز الترويجي",
    refundRequests: "طلبات الاسترداد",
  },
  error: {
    required: "هذا الحقل مطلوب",
    validation1: "الرجاء اختيار فيديو صالح",
    maxValidation: "الحد الأقصى المسموح به 80 حرفًا",
    maxValidation200: "الحد الأقصى المسموح به 200 حرفًا",
    minValidation: "الحد الأدنى المطلوب 3 أحرف",
    noData: "لم يتم العثور على نتائج",
    titlereq: "العنوان مطلوب",
    descReq: "الوصف مطلوب",
    noFaq: "لم يتم العثور على قائمة الأسئلة الشائعة",
    emailReq: "البريد الإلكتروني مطلوب!",
    validEmail: "أدخل عنوان بريد إلكتروني صالح!",
    firstReq: "الاسم الأول مطلوب",
    lastReq: "اسم العائلة مطلوب",
    phoneReq: "رقم الهاتف مطلوب",
    minPhone: "يجب أن يكون رقم الهاتف 6 أرقام على الأقل",
    maxPhone: "يجب أن يكون رقم الهاتف 16 رقمًا كحد أقصى",
    subAdminCreated: "تم إنشاء المسؤول الفرعي بنجاح",
    subAdminUpdate: "تم تحديث المسؤول الفرعي بنجاح",
    userUpdate: "تم تحديث المستخدم بنجاح",
    statusUpdate: "تم تحديث الحالة بنجاح",
    subAdminDel: "تم حذف المسؤول الفرعي بنجاح",
    userDel: "تم حذف المستخدم بنجاح",
    max100: "الحد الأقصى المسموح به 100 حرف",
    max250: "الحد الأقصى المسموح به 250 حرفًا",
    max500: "الحد الأقصى المسموح به 500 حرف",
    catAdd: "تم إضافة الفئة بنجاح",
    catUpdate: "تم تحديث الفئة بنجاح",
    settingUpdate: "تم تحديث الإعدادات بنجاح",
    faqAdd: "تم إضافة الأسئلة الشائعة بنجاح",
    faqUpd: "تم تحديث الأسئلة الشائعة بنجاح",
    faqDel: "تم حذف الأسئلة الشائعة بنجاح",
    cmsUpdate: "تم تحديث CMS بنجاح",
    messageReq: "الرسالة مطلوبة",
    notiAdd: "تم إضافة الإشعار بنجاح",
    notiDel: "تم حذف الإشعار بنجاح",
    notiSent: "تم إرسال الإشعار بنجاح",
    maxValidation20: "الحد الأقصى المسموح به 20 حرفًا",
    maxValidation450: "الحد الأقصى المسموح به 450 حرفًا",
    logutReq: "هل أنت متأكد من أنك تريد تسجيل الخروج؟",
    pleaseTryAgain: "يرجى المحاولة مرة أخرى",
    catDel: "تم حذف الفئة بنجاح",
    subCatDel: "تم حذف الفئة الفرعية بنجاح",
    subCatAdd: "تمت إضافة الفئة الفرعية بنجاح",
    subCatUpdate: "تم تحديث الفئة الفرعية بنجاح",
    maxValidation30: "الحد الأقصى المسموح به 30 حرفًا",
    maxValidation15: "الحد الأقصى المسموح به 15 حرفًا",
    minValidation2: "الحد الأدنى المطلوب حرفان",
    imagesOnly: "هذا الحقل يقبل الصور فقط.",
    creditsAdded: "تمت إضافة الرصيد بنجاح",
    tutorialUpdate: "تم تحديث البرنامج التعليمي بنجاح",
    tutorialAdd: "تمت إضافة البرنامج التعليمي بنجاح",
    tutorialDel: "تم حذف البرنامج التعليمي بنجاح",
    planUpdate: "تم تحديث الباقة بنجاح",
    planAdd: "تمت إضافة الباقة بنجاح",
    subDel: "تم حذف الاشتراك بنجاح",
    propertyDel: "تم حذف العقار بنجاح",
    propertyUpdate: "تم تحديث العقار بنجاح",
    propertyAdd: "تمت إضافة العقار بنجاح",
    exportFailed: "فشل التصدير. يرجى المحاولة مرة أخرى.",
    invalidVideo: "الرجاء اختيار فيديو صالح",
    invalidVideoFormat: "صيغة ملف غير صالحة: يُسمح بملفات الفيديو فقط",
    uploadFailed: "فشل الرفع. يرجى المحاولة مرة أخرى.",
    invalidFileType: "نوع ملف غير صالح. يرجى رفع الصور أو الفيديو فقط.",
    maxMediaSeven: "لا يمكن رفع أكثر من 7 صور أو فيديوهات",
    fillOneCreditField: "يرجى ملء حقل رصيد واحد على الأقل",
    noSpacesOnly: "لا يمكن أن يحتوي هذا الحقل على مسافات فقط",
    permissionRequired: "يجب تحديد صلاحية واحدة على الأقل",
    profileUpdated: "تم تحديث الملف الشخصي بنجاح",
  },
  discount: {
    promoCodeDeleted: "تم حذف الرمز الترويجي بنجاح",
    noPromoCodeFound: "لم يتم العثور على رمز ترويجي",
    promoCodeUpdated: "تم تحديث الرمز الترويجي بنجاح",
    promoCodeAdded: "تمت إضافة الرمز الترويجي بنجاح",
    percentage: "نسبة مئوية",
    flat: "ثابت",
    highlighted: "مميز",
    normal: "عادي",
    both: "كلاهما",
  },
  payment: {
    dateOfPurchase: "تاريخ الشراء",
    credits: "الاعتمادات",
    subscription: "الاشتراك",
    agentRequest: "طلب الوكيل",
    transactionId: "رقم المعاملة",
    providerChargeId: "معرّف الشحن لدى المزود",
    paymentStatus: "حالة الدفع",
    providerStatus: "حالة المزود",
    pending: "قيد الانتظار",
    completed: "مكتمل",
    cancelled: "ملغى",
    refunded: "مسترد",
    failureReason: "سبب الفشل",
    noPaymentsFound: "لم يتم العثور على مدفوعات",
    card: "بطاقة",
  },
  roundUp: {
    title: "إدارة تكوين التقريب",
    minimumLimit: "الحد الأدنى",
    maximumLimit: "الحد الأقصى",
    numberOfBreakpoints: "عدد نقاط التوقف",
    numberOfBreakPointsPlaceholder: "عدد نقاط التوقف",
    multipliers: "المضاعفات",
    addMultiplier: "إضافة مضاعف",
    multiplier: "المضاعف",
  },

  plans: {
    planName: "اسم الخطة",
    planValid: "صلاحية الخطة",
    planPrice: "سعر الخطة",
    feature: "الميزات",
  },
  user: {
    Actions: "أجراءات",
    Credits: "الاعتمادات",
    AccountStatus: "حالة الحساب",
    Email: "بريد إلكتروني",
    PhoneNo: "رقم الهاتف",
    Name: "اسم",
    SNo: "رقم S",
    ManageUsers: "ادارة المستخدمين",
    ExportCsv: "تصدير ملف CSV",
    SearchHere: "ابحث هنا",
    Showing: "عرض",
    items: "أغراض",
    AddCredits: "إضافة الاعتمادات",
    HighlightedCredits: "الاعتمادات المميزة",
    NormalCredits: "الاعتمادات العادية",
    ViewUserProfile: "عرض ملف تعريف المستخدم",
    noUsersFound: "لم يتم العثور على مستخدمين",
    view: "عرض",
    edit: "تعديل",
    delete: "حذف",
  },
  agents: {
    Actions: "أجراءات",
    Credits: "الاعتمادات",
    AccountStatus: "حالة الحساب",
    Email: "بريد إلكتروني",
    PhoneNo: "رقم الهاتف",
    Name: "اسم",
    SNo: "رقم S",
    ManageAgents: "إدارة الوكلاء",
    ExportCsv: "تصدير ملف CSV",
    SearchHere: "ابحث هنا",
    Showing: "عرض",
    items: "أغراض",
    AddCredits: "إضافة الاعتمادات",
    HighlightedCredits: "الاعتمادات المميزة",
    NormalCredits: "الاعتمادات العادية",
    NoAgentFound: "لم يتم العثور على وكيل",
    Cancel: "يلغي",
    Add: "يضيف",
    Agent: "عامل",
    ViewAgentProfile: "عرض الملف التعريفي للوكيل",
    Subscribed: "مشترك",
    allAgentsNewest: "جميع الوكلاء (الأحدث)",
    pendingLicense: "بانتظار الرخصة",
    acceptedLicense: "مقبولة",
    rejectedLicense: "مرفوضة",
    documentStatusUpdated: "تم تحديث حالة المستند",
    agentDeleted: "تم حذف الوكيل بنجاح",
    pending: "قيد الانتظار",
    documentStatus: "حالة المستند",
    accepted: "مقبول",
    accept: "قبول",
    rejected: "مرفوض",
    reject: "رفض",
    subscribedYes: "نعم",
    subscribedNo: "لا",
    profile: "الملف الشخصي",
    licenseDocuments: "مستندات الرخصة",
    normalCreditsBought: "الاعتمادات العادية المشتراة",
    highlightedCreditsBought: "الاعتمادات المميزة المشتراة",
    planSubscriptionDetails: "تفاصيل اشتراك الباقة",
    request: "الطلب",
    totalRequestsPlan: "إجمالي الطلبات (الباقة)",
    requestsUsed: "الطلبات المستخدمة",
    remainingRequests: "الطلبات المتبقية",
    normalCreditsPlan: "الاعتمادات العادية (الباقة)",
    normalCreditsUsed: "الاعتمادات العادية المستخدمة",
    normalCreditsAvailable: "الاعتمادات العادية المتاحة",
    highlightCreditsPlan: "اعتمادات التمييز (الباقة)",
    highlightsCreditsUsed: "اعتمادات التمييز المستخدمة",
    highlightsCreditsAvailable: "اعتمادات التمييز المتاحة",
    noLicenseDocument: "لم يتم رفع مستند الرخصة",
    viewLicense: "عرض الرخصة",
    downloadLicense: "تحميل الرخصة",
    requestToAgentCredits: "رصيد طلبات الوكيل",
    acceptRequestCredits: "رصيد طلبات القبول",
  },
  cms: {
    linkAdded: "تمت إضافة الرابط بنجاح",
    linkDeleted: "تم حذف الرابط بنجاح",
    addLinks: "إضافة روابط",
    linkTitle: "العنوان",
    linkTitleAr: "العنوان (عربي)",
    linkUrl: "الرابط",
    linkIcon: "الأيقونة",
    linkIconRequired: "يرجى رفع أيقونة",
    contactSupportUpdated: "تم تحديث دعم التواصل بنجاح",
    privacyPolicyUpdated: "تم تحديث سياسة الخصوصية بنجاح",
    termsUpdated: "تم تحديث الشروط والأحكام بنجاح",
    agentTermsUpdated: "تم تحديث شروط وأحكام الوكيل بنجاح",
    creditPriceUpdated: "تم تحديث سعر الرصيد بنجاح",
    appSettingsUpdated: "تم تحديث إعدادات التطبيق بنجاح",
    appUpdate: "تحديث التطبيق",
    forceUpdate: "تحديث إجباري",
    maintenance: "الصيانة",
    appSettingsDescription:
      "إدارة تحديث التطبيق وفرض التحديث ووضع الصيانة لكل منصة. اضبط الإصدار أعلى من إصدار التطبيق المثبت لإظهار نوافذ التحديث.",
    appSettingsHint:
      "السيناريوهات: (1) تفعيل تحديث التطبيق + إصدار أعلى = نافذة تحديث اختيارية. (2) تفعيل التحديث الإجباري + إصدار أعلى = نافذة تحديث إلزامية. (3) تفعيل الصيانة = نافذة الصيانة.",
    platformType: "النوع",
    version: "الإصدار",
    forceUpdates: "تحديثات إجبارية",
    maintenanceMode: "وضع الصيانة",
    lastUpdated: "آخر تحديث",
    featureSettings: "إعدادات Tap & Pay",
    quickCheckoutFeature: "تفعيل Tap & Pay",
    featureSettingsDescription: "تفعيل أو تعطيل خيار الدفع عبر Tap & Pay لمستخدمي تطبيق الهاتف المحمول.",
    featureSettingsUpdated: "تم تحديث إعدادات Tap & Pay بنجاح",
    userLabel: "user",
    versionRequiredForUpdate:
      "اضبط إصداراً أعلى من إصدار التطبيق الحالي لتفعيل تحديث التطبيق / التحديث الإجباري.",
    publicLinksTitle: "الروابط العامة",
    publicLinksDescription:
      "استخدم هذه الروابط في App Store Connect وGoogle Play Console لسياسة الخصوصية والشروط والدعم.",
    publicLinksPage: "الصفحة",
    publicLinksUrl: "الرابط العام",
    publicLinksCopy: "نسخ الرابط",
    publicLinksOpen: "فتح في تبويب جديد",
    publicLinksCopied: "تم نسخ الرابط",
  },
  areas: {
    governorateDeleted: "تم حذف المحافظة بنجاح",
    governorateUpdated: "تم تحديث المحافظة بنجاح",
    governorateAdded: "تمت إضافة المحافظة بنجاح",
    byAlphabets: "حسب الأبجدية",
    byAreas: "حسب المناطق",
    keyLabel: "المفتاح",
  },
  labels: {
    labelDeleted: "تم حذف التسمية بنجاح",
    labelSaved: "تم حفظ التسميات بنجاح",
    saleRentExchange: "تسميات البيع / الإيجار / التبادل",
    englishLabel: "التسمية بالإنجليزية",
    arabicLabel: "التسمية بالعربية",
    manageLabels: "إدارة التسميات",
    addLabels: "إضافة تسميات",
    labelAdded: "تمت إضافة التسمية بنجاح",
  },
  refunds: {
    statusUpdated: "تم تحديث حالة الاسترداد بنجاح",
    pending: "قيد الانتظار",
    refunded: "تم الاسترداد",
    manageRefunds: "طلبات الاسترداد",
    refundedAmount: "المبلغ المسترد",
    dateOfRequest: "تاريخ طلب الاسترداد",
    userName: "اسم المستخدم",
    userEmail: "البريد الإلكتروني للمستخدم",
    userPhone: "هاتف المستخدم",
    refundStatus: "حالة الاسترداد",
    filter: "تصفية",
    refundAction: "استرداد",
    cancelled: "ملغى",
    statusUpdateFailed: "فشل تحديث حالة الاسترداد",
    updateError: "خطأ في تحديث حالة الاسترداد",
    noRefundsFound: "لم يتم العثور على طلبات استرداد",
  },
  tutorials: {
    titleEn: "العنوان (إنجليزي)",
    titleAr: "العنوان (عربي)",
    descEn: "الوصف (إنجليزي)",
    descAr: "الوصف (عربي)",
  },
  subscription: {
    planNameEn: "اسم الباقة (إنجليزي)",
    planNameAr: "اسم الباقة (عربي)",
    descEn: "الوصف (إنجليزي)",
    descAr: "الوصف (عربي)",
    planPrice: "سعر الباقة",
    highlightedCredits: "رصيد الإعلانات المميزة",
    acceptRequest: "طلبات القبول",
    active: "نشط",
    expired: "منتهي",
    cancelled: "ملغى",
    noPurchases: "لا توجد اشتراكات مشتراة",
  },
  properties: {
    propertyDetails: "تفاصيل العقار",
    aboutProperty: "عن العقار",
    imagesAndVideos: "الصور والفيديوهات",
    mapLink: "رابط الخريطة",
    mtSq: "متر مربع",
    clearFilters: "مسح الفلاتر",
    selectArea: "اختر المنطقة",
    listingNormal: "عادي",
    listingHighlighted: "مميز",
    listingAgent: "وكيل",
    requestToAgent: "طلب إلى الوكيل",
    byAdmin: "بواسطة المشرف",
    customTitle: "العنوان المخصص",
    views: "المشاهدات",
    listingType: "نوع الإدراج",
    listingStatus: "حالة الإدراج",
    blockStatus: "حالة الحظر",
    propertyType: "نوع العقار",
    createdBy: "أنشئ بواسطة",
    sell: "بيع",
    rent: "إيجار",
    exchange: "تبديل",
    pending: "قيد الانتظار",
    published: "منشور",
    expired: "منتهي",
    draft: "مسودة",
    saveForLater: "حفظ للاحقاً",
    rejected: "مرفوض",
    sold: "مباع",
    rtaTimeout: "انتهاء مهلة RTA",
    refundInProgress: "استرداد قيد التنفيذ",
    negotiablePrice: "سعر قابل للتفاوض",
    dontDisturb: "عدم الإزعاج",
    publishedFlag: "منشور",
    searchCount: "عدد البحث",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    createdAt: "تاريخ الإنشاء",
    publishedAt: "تاريخ النشر",
    highlightedAt: "تاريخ التمييز",
    expiredAt: "تاريخ الانتهاء",
    acceptedByAgentAt: "تاريخ قبول الوكيل",
    saveForLaterAt: "تاريخ الحفظ للاحقاً",
    expireStatus: "حالة الانتهاء",
    isResubmit: "أعيد التقديم",
    isRefundRequested: "تم طلب الاسترداد",
  },
  manageDiscount: {
    managePromotionalCode: "إدارة الرمز الترويجي",
    addPromotionalCode: "إضافة رمز ترويجي",
    discountCode: "رمز الخصم",
    discountName: "اسم الخصم",
    discountType: "نوع الخصم",
    couponType: "نوع الكوبون",
    discountValue: "قيمة الخصم",
    minAmountToApply: "الحد الأدنى للمبلغ المطلوب",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    status: "الحالة",
    percentage: "نسبة مئوية",
    flat: "مبلغ ثابت",
    highlighted: "مميز",
    normal: "عادي",
    both: "كلاهما",
    noPromotionalCodeFound: "لم يتم العثور على رمز ترويجي",
    promoCodeDeleted: "تم حذف الرمز الترويجي بنجاح",
    statusUpdated: "تم تحديث الحالة بنجاح",
    pleaseTryAgain: "حاول مرة اخرى",
    editPromotionalCode: "تعديل الرمز الترويجي",
    selectDiscountType: "اختر نوع الخصم",
    userType: "نوع المستخدم",
    applyCodeFor: "تطبيق الرمز لـ",
    selectedAgents: "الوكلاء المختارين",
    selectedUsers: "المستخدمين المختارين",
    selectedUsersAgents: "المستخدمون والوكلاء المختارون",
    allAgents: "جميع الوكلاء",
    allUsers: "جميع المستخدمين",
    allUsersAgents: "جميع المستخدمين والوكلاء",
    selectUsers: "اختر المستخدمين",
    searchUsers: "البحث عن مستخدمين",
    pleaseSelectDiscountType: "الرجاء تحديد نوع الخصم",
    pleaseSelectType: "الرجاء تحديد النوع",
    promoCodeUpdated: "تم تحديث الرمز الترويجي بنجاح",
    promoCodeAdded: "تم إضافة الرمز الترويجي بنجاح",
    max20: "الحد الأقصى المسموح به 20 حرفًا",
    min2: "الحد الأدنى المطلوب حرفان",
    percent: "نسبة مئوية",
  }
};
